import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import FilterPanel from './components/FilterPanel';
import AuditTable from './components/AuditTable';
import DetailPanel from './components/DetailPanel';
import SearchBar from './components/SearchBar';
import ComplianceStats from './components/ComplianceStats';

const AuditTrailAndComplianceViewer = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [selectedEntry, setSelectedEntry] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState({});
  const [searchQuery, setSearchQuery] = useState('');

  const mockAuditEntries = [
    {
      id: "AUD-2025-001234",
      timestamp: new Date("2025-11-26T14:23:15"),
      userName: "Schmidt, Anna",
      userId: "BA-2847",
      userRole: "Sachbearbeiter",
      department: "Kundenservice",
      action: "update",
      actionLabel: "Profil aktualisiert",
      affectedRecord: "Müller, Thomas (KL-45892)",
      recordType: "Kundenprofil",
      category: "Kundendaten",
      sensitivityLevel: "confidential",
      description: "Aktualisierung der Kontaktinformationen und Berufsangaben für Kunden Thomas Müller",
      ipAddress: "192.168.1.45",
      sessionId: "SES-8472-9384-2847",
      userAgent: "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36",
      status: "success",
      retentionPeriod: "7 Jahre",
      digitalSignature: "SHA256:a3f8b9c2d1e4f5g6h7i8j9k0l1m2n3o4p5q6r7s8t9u0v1w2x3y4z5",
      changes: {
        before: { telefon: "030-12345678", beruf: "Ingenieur" },
        after: { telefon: "030-87654321", beruf: "Senior Ingenieur" }
      }
    },
    {
      id: "AUD-2025-001235",
      timestamp: new Date("2025-11-26T14:18:42"),
      userName: "Weber, Michael",
      userId: "BA-3921",
      userRole: "Administrator",
      department: "IT-Administration",
      action: "create",
      actionLabel: "Benutzer erstellt",
      affectedRecord: "Neuer Benutzer (BA-4892)",
      recordType: "Benutzerkonto",
      category: "Benutzerverwaltung",
      sensitivityLevel: "restricted",
      description: "Erstellung eines neuen Benutzerkontos für Sachbearbeiter in der Abteilung Arbeitsvermittlung",
      ipAddress: "192.168.1.12",
      sessionId: "SES-3921-8473-1029",
      userAgent: "Mozilla/5.0 (Windows NT 10.0; Win64; x64) Chrome/120.0.0.0",
      status: "success",
      retentionPeriod: "10 Jahre",
      digitalSignature: "SHA256:b4g9c0d2e5f6g7h8i9j0k1l2m3n4o5p6q7r8s9t0u1v2w3x4y5z6",
      changes: {
        before: null,
        after: { benutzername: "BA-4892", rolle: "Sachbearbeiter", abteilung: "Arbeitsvermittlung" }
      }
    },
    {
      id: "AUD-2025-001236",
      timestamp: new Date("2025-11-26T14:15:28"),
      userName: "Fischer, Sarah",
      userId: "BA-1847",
      userRole: "Vorgesetzter",
      department: "Berichtswesen",
      action: "export",
      actionLabel: "Daten exportiert",
      affectedRecord: "Monatsbericht November 2025",
      recordType: "Bericht",
      category: "Berichte",
      sensitivityLevel: "internal",
      description: "Export des monatlichen Kundenstatistikberichts für November 2025 zur Vorlage bei der Geschäftsleitung",
      ipAddress: "192.168.1.78",
      sessionId: "SES-1847-2938-4756",
      userAgent: "Mozilla/5.0 (Windows NT 10.0; Win64; x64) Edge/120.0.0.0",
      status: "success",
      retentionPeriod: "5 Jahre",
      digitalSignature: "SHA256:c5h0d3e6f7g8h9i0j1k2l3m4n5o6p7q8r9s0t1u2v3w4x5y6z7",
      changes: null
    },
    {
      id: "AUD-2025-001237",
      timestamp: new Date("2025-11-26T14:12:05"),
      userName: "Becker, Klaus",
      userId: "BA-2938",
      userRole: "Sachbearbeiter",
      department: "Arbeitsvermittlung",
      action: "view",
      actionLabel: "Profil angesehen",
      affectedRecord: "Wagner, Lisa (KL-78234)",
      recordType: "Kundenprofil",
      category: "Kundendaten",
      sensitivityLevel: "confidential",
      description: "Einsicht in Kundenprofil zur Vorbereitung eines Beratungsgesprächs",
      ipAddress: "192.168.1.92",
      sessionId: "SES-2938-7483-2910",
      userAgent: "Mozilla/5.0 (Windows NT 10.0; Win64; x64) Firefox/121.0",
      status: "success",
      retentionPeriod: "7 Jahre",
      digitalSignature: "SHA256:d6i1e4f7g8h9i0j1k2l3m4n5o6p7q8r9s0t1u2v3w4x5y6z8",
      changes: null
    },
    {
      id: "AUD-2025-001238",
      timestamp: new Date("2025-11-26T14:08:33"),
      userName: "Hoffmann, Julia",
      userId: "BA-4729",
      userRole: "Sachbearbeiter",
      department: "Kundenservice",
      action: "create",
      actionLabel: "ID generiert",
      affectedRecord: "Neuer Kunde (KL-89456)",
      recordType: "Kunden-ID",
      category: "Kundendaten",
      sensitivityLevel: "confidential",
      description: "Generierung einer neuen eindeutigen Kunden-ID für Neuregistrierung",
      ipAddress: "192.168.1.56",
      sessionId: "SES-4729-3847-5621",
      userAgent: "Mozilla/5.0 (Windows NT 10.0; Win64; x64) Chrome/120.0.0.0",
      status: "success",
      retentionPeriod: "7 Jahre",
      digitalSignature: "SHA256:e7j2f5g8h9i0j1k2l3m4n5o6p7q8r9s0t1u2v3w4x5y6z9",
      changes: {
        before: null,
        after: { kundenId: "KL-89456", status: "Aktiv", erstelltAm: "2025-11-26T14:08:33" }
      }
    },
    {
      id: "AUD-2025-001239",
      timestamp: new Date("2025-11-26T14:05:17"),
      userName: "Schulz, Martin",
      userId: "BA-3847",
      userRole: "Sachbearbeiter",
      department: "Arbeitsvermittlung",
      action: "update",
      actionLabel: "Berufsdaten aktualisiert",
      affectedRecord: "Schneider, Peter (KL-23456)",
      recordType: "Kundenprofil",
      category: "Kundendaten",
      sensitivityLevel: "confidential",
      description: "Aktualisierung der Berufsbezeichnung und Qualifikationen nach Weiterbildungsabschluss",
      ipAddress: "192.168.1.34",
      sessionId: "SES-3847-9283-7456",
      userAgent: "Mozilla/5.0 (Windows NT 10.0; Win64; x64) Safari/17.0",
      status: "success",
      retentionPeriod: "7 Jahre",
      digitalSignature: "SHA256:f8k3g6h9i0j1k2l3m4n5o6p7q8r9s0t1u2v3w4x5y6z0",
      changes: {
        before: { beruf: "Mechaniker", qualifikationen: ["Grundausbildung"] },
        after: { beruf: "Mechatroniker", qualifikationen: ["Grundausbildung", "Meisterbrief"] }
      }
    },
    {
      id: "AUD-2025-001240",
      timestamp: new Date("2025-11-26T14:02:48"),
      userName: "Koch, Andrea",
      userId: "BA-5829",
      userRole: "Administrator",
      department: "Systemverwaltung",
      action: "delete",
      actionLabel: "Datensatz gelöscht",
      affectedRecord: "Testdaten (KL-00001)",
      recordType: "Kundenprofil",
      category: "Kundendaten",
      sensitivityLevel: "internal",
      description: "Löschung von Testdatensätzen nach Abschluss der Systemprüfung gemäß Datenschutzrichtlinien",
      ipAddress: "192.168.1.10",
      sessionId: "SES-5829-4738-2910",
      userAgent: "Mozilla/5.0 (Windows NT 10.0; Win64; x64) Chrome/120.0.0.0",
      status: "success",
      retentionPeriod: "7 Jahre",
      digitalSignature: "SHA256:g9l4h7i0j1k2l3m4n5o6p7q8r9s0t1u2v3w4x5y6z1",
      changes: {
        before: { kundenId: "KL-00001", name: "Test Benutzer", status: "Test" },
        after: null
      }
    },
    {
      id: "AUD-2025-001241",
      timestamp: new Date("2025-11-26T13:58:22"),
      userName: "Zimmermann, Frank",
      userId: "BA-2847",
      userRole: "Sachbearbeiter",
      department: "Kundenservice",
      action: "login",
      actionLabel: "Anmeldung",
      affectedRecord: "Benutzer BA-2847",
      recordType: "Sitzung",
      category: "Benutzerverwaltung",
      sensitivityLevel: "internal",
      description: "Erfolgreiche Benutzeranmeldung im System",
      ipAddress: "192.168.1.67",
      sessionId: "SES-2847-8374-5629",
      userAgent: "Mozilla/5.0 (Windows NT 10.0; Win64; x64) Firefox/121.0",
      status: "success",
      retentionPeriod: "3 Jahre",
      digitalSignature: "SHA256:h0m5i8j1k2l3m4n5o6p7q8r9s0t1u2v3w4x5y6z2",
      changes: null
    },
    {
      id: "AUD-2025-001242",
      timestamp: new Date("2025-11-26T13:55:09"),
      userName: "Krüger, Sabine",
      userId: "BA-4738",
      userRole: "Vorgesetzter",
      department: "Qualitätssicherung",
      action: "view",
      actionLabel: "Audit-Bericht angesehen",
      affectedRecord: "Compliance-Bericht Q4 2025",
      recordType: "Bericht",
      category: "Berichte",
      sensitivityLevel: "restricted",
      description: "Einsicht in den vierteljährlichen Compliance-Bericht zur Qualitätsprüfung",
      ipAddress: "192.168.1.89",
      sessionId: "SES-4738-2938-7456",
      userAgent: "Mozilla/5.0 (Windows NT 10.0; Win64; x64) Edge/120.0.0.0",
      status: "success",
      retentionPeriod: "10 Jahre",
      digitalSignature: "SHA256:i1n6j9k2l3m4n5o6p7q8r9s0t1u2v3w4x5y6z3",
      changes: null
    },
    {
      id: "AUD-2025-001243",
      timestamp: new Date("2025-11-26T13:51:44"),
      userName: "Braun, Thomas",
      userId: "BA-3829",
      userRole: "Sachbearbeiter",
      department: "Arbeitsvermittlung",
      action: "update",
      actionLabel: "Adresse aktualisiert",
      affectedRecord: "Meyer, Anna (KL-56789)",
      recordType: "Kundenprofil",
      category: "Kundendaten",
      sensitivityLevel: "confidential",
      description: "Aktualisierung der Wohnadresse nach Umzugsmeldung des Kunden",
      ipAddress: "192.168.1.43",
      sessionId: "SES-3829-7483-9201",
      userAgent: "Mozilla/5.0 (Windows NT 10.0; Win64; x64) Chrome/120.0.0.0",
      status: "success",
      retentionPeriod: "7 Jahre",
      digitalSignature: "SHA256:j2o7k0l3m4n5o6p7q8r9s0t1u2v3w4x5y6z4",
      changes: {
        before: { strasse: "Hauptstraße 12", plz: "10115", stadt: "Berlin" },
        after: { strasse: "Nebenstraße 45", plz: "10117", stadt: "Berlin" }
      }
    }
  ];

  const mockStats = {
    totalAudits: 45892,
    gdprCompliant: 45876,
    flaggedEntries: 16,
    activeUsers: 247,
    successRate: 99.8
  };

  const totalPages = Math.ceil(mockAuditEntries?.length / 10);

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
    setCurrentPage(1);
  };

  const handleResetFilters = () => {
    setFilters({});
    setSearchQuery('');
    setCurrentPage(1);
  };

  const handleSearch = (query) => {
    setSearchQuery(query);
    setCurrentPage(1);
  };

  const handleExport = () => {
    alert('Export-Funktion wird ausgeführt...\n\nDie Audit-Daten werden als CSV-Datei heruntergeladen.');
  };

  const handleSelectEntry = (entry) => {
    setSelectedEntry(entry);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setMobileMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <Helmet>
        <title>Audit Trail und Compliance | Bundesagentur für Arbeit</title>
        <meta name="description" content="Umfassende Audit-Trail-Übersicht und regulatorische Berichterstattung für DSGVO- und Bundesdatenschutz-Compliance" />
      </Helmet>
      <div className="min-h-screen bg-background">
        {/* Sidebar */}
        <aside className={`sidebar ${sidebarCollapsed ? 'collapsed' : ''} ${mobileMenuOpen ? '' : '-translate-x-full lg:translate-x-0'}`}>
          <div className="sidebar-header">
            <div className="sidebar-logo">
              <Icon name="Building2" size={24} color="white" />
            </div>
            <div className="sidebar-brand">
              <span className="text-sm font-semibold text-foreground">Bundesagentur</span>
              <span className="text-xs text-muted-foreground">für Arbeit</span>
            </div>
          </div>

          <nav className="sidebar-nav">
            <div className="sidebar-section">
              <div className="sidebar-section-title">Hauptmenü</div>
              <a href="/case-worker-dashboard" className="sidebar-item">
                <Icon name="LayoutDashboard" size={20} className="sidebar-item-icon" />
                <span className="sidebar-item-text">Dashboard</span>
              </a>
              <a href="/client-search-and-directory" className="sidebar-item">
                <Icon name="Search" size={20} className="sidebar-item-icon" />
                <span className="sidebar-item-text">Kundensuche</span>
              </a>
              <a href="/client-profile-management" className="sidebar-item">
                <Icon name="Users" size={20} className="sidebar-item-icon" />
                <span className="sidebar-item-text">Kundenverwaltung</span>
              </a>
              <a href="/unique-id-generation-system" className="sidebar-item">
                <Icon name="Hash" size={20} className="sidebar-item-icon" />
                <span className="sidebar-item-text">ID-Generierung</span>
              </a>
            </div>

            <div className="sidebar-section">
              <div className="sidebar-section-title">Verwaltung</div>
              <a href="/bulk-operations-center" className="sidebar-item">
                <Icon name="Package" size={20} className="sidebar-item-icon" />
                <span className="sidebar-item-text">Massenoperationen</span>
              </a>
              <a href="/supervisor-dashboard-and-analytics" className="sidebar-item">
                <Icon name="BarChart3" size={20} className="sidebar-item-icon" />
                <span className="sidebar-item-text">Analysen</span>
              </a>
              <a href="/system-administration-panel" className="sidebar-item">
                <Icon name="Settings" size={20} className="sidebar-item-icon" />
                <span className="sidebar-item-text">Systemverwaltung</span>
              </a>
              <a href="/audit-trail-and-compliance-viewer" className="sidebar-item active">
                <Icon name="Shield" size={20} className="sidebar-item-icon" />
                <span className="sidebar-item-text">Audit & Compliance</span>
              </a>
            </div>
          </nav>
        </aside>

        {/* Mobile Overlay */}
        {mobileMenuOpen && (
          <div className="mobile-overlay" onClick={() => setMobileMenuOpen(false)} />
        )}

        {/* Mobile Menu Button */}
        <button
          className={`mobile-menu-button ${mobileMenuOpen ? 'sidebar-open' : ''}`}
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          <Icon name={mobileMenuOpen ? 'X' : 'Menu'} size={24} />
        </button>

        {/* Header */}
        <header className={`header ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
          <div className="header-content">
            <div className="header-left">
              <button
                onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
                className="hidden lg:flex p-2 rounded-md hover:bg-muted transition-colors"
              >
                <Icon name={sidebarCollapsed ? 'ChevronRight' : 'ChevronLeft'} size={20} />
              </button>
              <div className="breadcrumb">
                <span className="breadcrumb-item">
                  <a href="/case-worker-dashboard" className="breadcrumb-link">Dashboard</a>
                </span>
                <Icon name="ChevronRight" size={16} className="breadcrumb-separator" />
                <span className="breadcrumb-current">Audit Trail und Compliance</span>
              </div>
            </div>

            <div className="header-right">
              <div className="session-timer">
                <Icon name="Clock" size={16} />
                <span>45:23</span>
              </div>

              <div className="notification-button">
                <Icon name="Bell" size={20} />
                <span className="notification-badge"></span>
              </div>

              <div className="header-user">
                <div className="header-user-avatar">AS</div>
                <div className="header-user-info">
                  <div className="header-user-name">Anna Schmidt</div>
                  <div className="header-user-role">Administrator</div>
                </div>
              </div>
            </div>
          </div>
        </header>

        {/* Main Content */}
        <main className={`main-content ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
          <div className="p-6">
            {/* Page Header */}
            <div className="mb-6">
              <div className="flex items-center justify-between mb-2">
                <h1 className="text-3xl font-bold text-foreground flex items-center gap-3">
                  <Icon name="Shield" size={32} className="text-primary" />
                  Audit Trail und Compliance Viewer
                </h1>
                <div className="flex items-center gap-2">
                  <Button variant="outline" iconName="FileDown" iconPosition="left">
                    Compliance-Bericht
                  </Button>
                  <Button variant="default" iconName="AlertCircle" iconPosition="left">
                    Anomalien prüfen
                  </Button>
                </div>
              </div>
              <p className="text-muted-foreground">
                Umfassende Audit-Trail-Übersicht und regulatorische Berichterstattung für DSGVO- und Bundesdatenschutz-Compliance
              </p>
            </div>

            {/* Compliance Stats */}
            <ComplianceStats stats={mockStats} />

            {/* Search Bar */}
            <SearchBar
              onSearch={handleSearch}
              onExport={handleExport}
              totalResults={mockAuditEntries?.length}
            />

            {/* Main Layout */}
            <div className="grid grid-cols-12 gap-4 mt-4">
              {/* Filter Panel - 25% */}
              <div className="col-span-12 lg:col-span-3">
                <div className="bg-card rounded-lg border border-border h-[calc(100vh-28rem)] overflow-hidden">
                  <FilterPanel
                    onFilterChange={handleFilterChange}
                    onReset={handleResetFilters}
                  />
                </div>
              </div>

              {/* Audit Table - 60% */}
              <div className="col-span-12 lg:col-span-6">
                <div className="bg-card rounded-lg border border-border h-[calc(100vh-28rem)] overflow-hidden">
                  <AuditTable
                    entries={mockAuditEntries}
                    onSelectEntry={handleSelectEntry}
                    selectedEntry={selectedEntry}
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                  />
                </div>
              </div>

              {/* Detail Panel - 15% */}
              <div className="col-span-12 lg:col-span-3">
                <div className="bg-card rounded-lg border border-border h-[calc(100vh-28rem)] overflow-hidden">
                  <DetailPanel
                    entry={selectedEntry}
                    onClose={() => setSelectedEntry(null)}
                  />
                </div>
              </div>
            </div>

            {/* Keyboard Shortcuts Info */}
            <div className="mt-6 bg-muted/30 rounded-lg p-4">
              <div className="flex items-start gap-3">
                <Icon name="Keyboard" size={20} className="text-primary mt-0.5" />
                <div className="flex-1">
                  <h3 className="text-sm font-semibold text-foreground mb-2">Tastaturkürzel</h3>
                  <div className="grid grid-cols-3 gap-4 text-xs text-muted-foreground">
                    <div><kbd className="px-2 py-1 bg-card rounded border border-border">Strg+F</kbd> Suche öffnen</div>
                    <div><kbd className="px-2 py-1 bg-card rounded border border-border">Strg+E</kbd> Exportieren</div>
                    <div><kbd className="px-2 py-1 bg-card rounded border border-border">Strg+R</kbd> Filter zurücksetzen</div>
                    <div><kbd className="px-2 py-1 bg-card rounded border border-border">↑/↓</kbd> Navigation</div>
                    <div><kbd className="px-2 py-1 bg-card rounded border border-border">Enter</kbd> Details öffnen</div>
                    <div><kbd className="px-2 py-1 bg-card rounded border border-border">Esc</kbd> Details schließen</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default AuditTrailAndComplianceViewer;